import React, { useRef, useEffect, useState } from 'react';
import LazyImage from '@/components/LazyImage'; // 引入懒加载组件，请确认路径正确

const Content2 = () => {
    const imgRef = useRef(null);
    const canvasRef = useRef(null);
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    const [hoveredLetter, setHoveredLetter] = useState(null);

    const LETTERS = [
        { letter: 'V', x: 40, y: 80, width: 200, height: 320 },
        { letter: 'I', x: 240, y: 80, width: 150, height: 320 },
        { letter: 'T', x: 390, y: 80, width: 168, height: 320 },
        { letter: 'O', x: 558, y: 80, width: 200, height: 320 },
    ];

    const ORIGINAL_IMG_WIDTH = 800;
    const ORIGINAL_IMG_HEIGHT = 600;

    const getScaledLetters = () => {
        if (!dimensions.width) return [];
        const scaleX = dimensions.width / ORIGINAL_IMG_WIDTH;
        const scaleY = dimensions.height / ORIGINAL_IMG_HEIGHT;
        return LETTERS.map(letter => ({
            ...letter,
            x: letter.x * scaleX,
            y: letter.y * scaleY,
            width: letter.width * scaleX,
            height: letter.height * scaleY,
        }));
    };

    const handleMouseMove = (e) => {
        const letters = getScaledLetters();
        const rect = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const currentLetter = letters.find(letter =>
            x >= letter.x && x <= letter.x + letter.width &&
            y >= letter.y && y <= letter.y + letter.height
        );

        setHoveredLetter(currentLetter?.letter || null);
    };

    const handleMouseLeave = () => {
        setHoveredLetter(null);
    };

    const updateDimensions = () => {
        if (imgRef.current) {
            setDimensions({
                width: imgRef.current.offsetWidth,
                height: imgRef.current.offsetHeight,
            });
        }
    };

    useEffect(() => {
        updateDimensions();
        window.addEventListener('resize', updateDimensions);
        return () => window.removeEventListener('resize', updateDimensions);
    }, []);

    useEffect(() => {
        if (!canvasRef.current || !dimensions.width) return;
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        canvas.width = dimensions.width;
        canvas.height = dimensions.height;
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        getScaledLetters().forEach(letter => {
            ctx.strokeStyle = 'rgba(0, 255, 0, 0)'; // 隐藏调试边框
            ctx.strokeRect(letter.x, letter.y, letter.width, letter.height);
        });
    }, [dimensions]);

    return (
        <div style={{ position: 'relative', width: '100%' }} id="about">
            {/* 背景图 */}
            <LazyImage
                innerRef={imgRef}
                src={require('@/assets/image/vito/拆分底图 3.jpg')}
                style={{
                    width: '100%',
                    display: 'block',
                    position: 'relative',
                    zIndex: 1,
                }}
                onLoad={updateDimensions}
                onMouseMove={handleMouseMove}
                onMouseLeave={handleMouseLeave}
                alt=""
            />

            {/* 鼠标悬停字母图层 */}
            {['V', 'I', 'T', 'O'].map((letter) => (
                <LazyImage
                    key={letter}
                    src={require(`@/assets/image/vito/${letter}1.jpg`)}
                    style={{
                        width: '100%',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        objectFit: 'cover',
                        objectPosition: 'top',
                        pointerEvents: 'none',
                        zIndex: 2,
                        opacity: hoveredLetter === letter ? 1 : 0,
                        transition: 'opacity 0.5s ease-in-out',
                    }}
                    alt=""
                    onError={(e) => (e.target.style.display = 'none')}
                />
            ))}

            <canvas
                ref={canvasRef}
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    pointerEvents: 'none',
                    zIndex: 3,
                }}
            />
        </div>
    );
};

export default Content2;
